var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #c1d6ef;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #1e4ec6;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thank-You"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thank-you"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "m82.19,0H18.81C8.44,0,0,8.44,0,18.81v52.18c0,10.37,8.44,18.81,18.81,18.81h19.26l10.34,10.34c.58.58,1.33.87,2.09.87s1.51-.29,2.09-.87l10.34-10.34h19.26c10.37,0,18.81-8.44,18.81-18.81V18.81c0-10.37-8.44-18.81-18.81-18.81h0Zm12.89,70.99c0,7.11-5.78,12.89-12.89,12.89h-20.49c-.78,0-1.54.31-2.09.87l-9.11,9.11-9.11-9.11c-.55-.56-1.31-.87-2.09-.87h-20.49c-7.11,0-12.89-5.78-12.89-12.89V18.81c0-7.11,5.78-12.89,12.89-12.89h63.39c7.11,0,12.89,5.78,12.89,12.89v52.18Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.31,52.17v-13.47h8.68v2.85h-5.68v2.85h5v2.74h-4.98v5.03h-3.02Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.03,49.43h-5.21l-.97,2.74h-3.15l5.07-13.47h3.48l5.02,13.47h-3.27l-.97-2.74Zm-4.22-2.74h3.27l-1.61-4.65-1.65,4.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m43.92,52.17v-13.47h3.04v13.47h-3.04Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m49.87,52.17v-13.47h3v10.6h5.81v2.87h-8.81Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m60.62,52.17v-13.47h8.53v2.83h-5.53v2.56h5.02v2.64h-5.02v2.58h5.55v2.85h-8.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m71.7,52.17v-13.47h4.88c4.05,0,6.76,2.58,6.76,6.74s-2.72,6.72-6.78,6.72h-4.86Zm4.75-2.83c2.07,0,3.76-1.2,3.76-3.89s-1.69-3.91-3.76-3.91h-1.75v7.81h1.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.5be220bcbd6fe0b97cd2cc0d27b55e37.svg";
export { ForwardRef as ReactComponent };